import { Box, Breadcrumbs, Typography } from '@mui/material'
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {  NEWPURCHASE, PURCHASECREDITNOTE, SIMPLEPURCHASE } from '../Routes/constURL'
import CustomButton from './CustomButton'
import { useNavigation } from '../context/NavigationContext'

const BreadcrumbsComp = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { isFormDirtyCondition, setIsFormDirtyCondition } = useNavigation(); 
  const path = location.pathname;
  const pathArray = path.split("/").filter(Boolean).map(item =>
    item.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
  );
  const handleBack = ()=> {
    if (isFormDirtyCondition && !window.confirm('You have unsaved changes. Are you sure you want to leave?')) {
        return;                                   
      }
    else {
      navigate(SIMPLEPURCHASE);
      setIsFormDirtyCondition(false);
    }
    }

  return (
    <Box sx={{ borderBottom: "1px solid black", borderTop: "1px solid black", display: "flex", flexDirection: { xs: "column", sm: "row" },  justifyContent: { xs: "flex-start", sm: "space-between" }, alignItems: { xs: "flex-start", sm: "center" } ,fontSize:'0.8rem'}}>
      {
        <Breadcrumbs aria-label="breadcrumb" sx={{ p: 1, pl: 4, display: "flex", alignItems: "center" }}>
          <Typography sx={{fontSize:'0.8rem'}}>{"Home"}</Typography>
          {pathArray.map((item) => <Link underline="hover" color="inherit" href="/" style={{ color: "black", textDecoration: "none",fontSize:'0.8rem' }}>
            {item}
          </Link>
          )}
        </Breadcrumbs>

      }
      {(location.pathname === NEWPURCHASE)  && <Box sx={{ width: 'fit-content', justifyContent: "space-around", display: "flex", gap: 2, alignItems: "center" , paddingY: "10px", paddingX: "30px" }}>
        <CustomButton text={"Save"} bgcolor={"#95ABEB"} color={'black'} />
        <CustomButton text={"Back to List "} border={"#000"} img={require('../assets/Shape (1).png')} color={'black'}  onClick={()=>navigate(SIMPLEPURCHASE)}/>
      </Box>}
      {( location.pathname === PURCHASECREDITNOTE)  && <Box sx={{ width: 'fit-content', justifyContent: "space-around", display: "flex", gap: 2, alignItems: "center" , paddingY: "10px", paddingX: "30px" }}>
        <CustomButton text={"Save"} bgcolor={"#95ABEB"} color={'black'} />
        <CustomButton text={"Back to List "} border={"#000"} img={require('../assets/Shape (1).png')} color={'black'}  onClick={handleBack}/>
      </Box>}
    </Box>)
}

export default BreadcrumbsComp